<template>
    <div>   
        <h2 class="primary darken-2 white--text font-weight-bold subheading pt-1 text-xs-center">
            Deposit History
        </h2>
        <v-divider></v-divider>
        <div class="deposit-container" style="max-height: 400px; overflow: auto"> 
            <v-card 
                color="white" 
                v-for="transaction in deposits"
                :key="transaction.id"
                class="mb-1"
            >
                <v-card-text class="px-3 py-2" style="font-size: 12px; cursor: pointer">
                    <div class="d-flex justify-space-between align-center">
                        <h2 class="teal--text">
                            Status: 
                            <span :class="statusColorClass(transaction.status)">
                                {{ transactionStatus(transaction.status) }}
                            </span>
                        </h2>
                        <v-chip v-if="transaction.campaign" small color="orange lighten-4">
                            <v-icon small left>mdi-campaign</v-icon>
                            {{ transaction.campaign.name }}
                        </v-chip>
                    </div>
                    
                    <div class="mt-1">
                        <b>Amount:</b> {{ transaction.amount }} FCFA
                    </div>
                    
                    <div class="mt-1">
                        <b>Date:</b> {{ formatDate(transaction.date) }} at {{ transaction.time }}
                    </div>
                    
                    <v-spacer></v-spacer>
                    
                    <div class="mt-1 deposit-details">
                        <span v-if="transaction.payment_method">
                            <v-icon small>mdi-credit-card</v-icon>
                            {{ transaction.payment_method }} 
                            <span v-if="transaction.user_phone">({{ transaction.user_phone }})</span>
                        </span>
                        <div class="mt-1 caption">
                            Ref: {{ transaction.reference }}
                        </div>
                    </div>
                    <div class="mt-1">
                        <span v-if="transaction.description">
                            <b>Description:</b> {{ transaction.description }}
                        </span>
                    </div>

                </v-card-text>
                <v-divider></v-divider>
            </v-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            deposits: []
        }
    },

    methods: {
        async getDepositHistory() {
            try {
                const response = await axios.get(
                    '/api/v1/home/get/user/transactions/null/null/deposits/'
                )
                this.deposits = response.data.results.map(d => ({
                    ...d,
                    isCampaign: !!d.campaign
                }))
            } catch (error) {
                this.handleError(error)
            }
        },

        statusColorClass(status) {
            return {
                'PENDING': 'blue--text',
                'COMPLETED': 'success--text',
                'CANCELLED': 'red--text',
                'PROCESSING': 'orange--text'
            }[status] || 'grey--text'
        },

        transactionStatus(status) {
            return {
                'PENDING': 'En attente',
                'COMPLETED': 'Complété',
                'CANCELLED': 'Annulé',
                'PROCESSING': 'En cours'
            }[status] || status
        },

        formatDate(dateStr) {
            const options = { year: 'numeric', month: 'short', day: 'numeric' }
            return new Date(dateStr).toLocaleDateString('fr-FR', options)
        },

        handleError(error) {
            const message = error.response?.data?.error || 'Erreur de chargement des dépôts'
            this.$store.commit('setSnackBarMessage', message)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
    },

    mounted() {
        this.getDepositHistory()
        document.title = "PettyCash | Historique des dépôts"
        this.$store.commit('setCloseURL', "/home/deposits/history")
    }
}
</script>

<style scoped>
.deposit-container {
    padding: 0 8px;
}

.v-chip {
    height: 22px;
    font-size: 0.75rem;
}

.deposit-details {
    border-top: 1px solid #eee;
    padding-top: 8px;
    margin-top: 8px;
}

.v-card:hover {
    transform: translateX(3px);
    transition: transform 0.3s ease;
}

.campaign-badge {
    position: absolute;
    right: 8px;
    top: 8px;
}

@media (max-width: 600px) {
    .d-flex.justify-space-between {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .v-chip {
        margin-top: 8px;
    }
}
</style>